// extracted by mini-css-extract-plugin
module.exports = {"tgl":"Switch__tgl__L5gJa","tgl-btn":"Switch__tgl-btn__iArpJ","tgl-light":"Switch__tgl-light__1eI86","highlight":"Switch__highlight__1UKy-"};